import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Grid from "@material-ui/core/Grid";
import API from "../../API";
import { LoadingOverlay } from "../../components/Navigation/LoadingOverlay";
import { FleetContext } from "../../context";
import VehicleDataWidget from "./VehicleDataWidget/VehicleDataWidget";
import VehicleHistoryWidgetContainer from "./VehicleHistoryWidget/VehicleHistoryWidgetContainer";
import DiagnosticModalContext from "./Modals/DiagnosticModal/DiagnosticModalContext";
import {
  TimelineStatus,
  TripTimelineStatus,
  BaseSortableByStartTime,
} from "../../services/timeline.service";

export const VehicleDetail = () => {
  const { fleetId, vehicleId } = useParams();
  const {
    activeVehicle,
    setActiveFleet,
    trips,
    fetchActiveVehicle,
    fetchActiveSIMConfig,
    fetchEventsMap,
    eventsMap,
    sanitizeEvent,
    vehicleTimelineStatuses,
  } = useContext(FleetContext);
  const [latestDiagnostics, setLatestDiagnostics] = useState([]);
  const [latestRawDiagnostics, setLatestRawDiagnostics] = useState([]);
  const [diagnosticsTimestamp, setDiagnosticsTimestamp] = useState("");
  const [timelineStatusesByDate, setTimelineStatusesByDate] = useState({});
  const [tripInfo, setTripInfo] = useState({});

  useEffect(() => {
    setActiveFleet(fleetId);
    fetchActiveVehicle(vehicleId);
    fetchActiveSIMConfig(vehicleId);
  }, [fleetId, vehicleId]);

  useEffect(() => {
    fetchEventsMap(activeVehicle);
  }, [activeVehicle?.id]);

  useEffect(() => {
    let statuses = vehicleTimelineStatuses || [];
    statuses = statuses.map((status) =>
      status.is_trip ? new TripTimelineStatus(status) : new TimelineStatus(status),
    );

    const tripTimelineStatuses = statuses.filter(({ is_trip: isTrip }) => isTrip);
    const statusesByDate = BaseSortableByStartTime.bucketByDate(statuses);

    setTripInfo(TripTimelineStatus.getTripInfo(tripTimelineStatuses));
    setTimelineStatusesByDate(statusesByDate);
  }, [vehicleTimelineStatuses]);

  const getDiagnostics = async () => {
    try {
      const { diagnosticsData, timestamp } = await API.vehicle.diagnostics(vehicleId);
      setDiagnosticsTimestamp(timestamp);
      setLatestRawDiagnostics(diagnosticsData);
      const sanitizedData = diagnosticsData.map((diagnostic) => sanitizeEvent(diagnostic));
      setLatestDiagnostics(sanitizedData);
    } catch (e) {
      console.error(e.message);
    }
  };

  if (!activeVehicle || !activeVehicle.components || Object.keys(eventsMap).length === 0)
    return <LoadingOverlay />;
  return (
    <DiagnosticModalContext.Provider
      value={{ latestDiagnostics, latestRawDiagnostics, diagnosticsTimestamp, getDiagnostics }}
    >
      <Grid container spacing={3}>
        {!trips && <LoadingOverlay />}
        <VehicleDataWidget vehicle={activeVehicle} />
        <VehicleHistoryWidgetContainer
          vehicle={activeVehicle}
          tripInfo={tripInfo}
          timelineStatusesByDate={timelineStatusesByDate}
        />
      </Grid>
    </DiagnosticModalContext.Provider>
  );
};

export default VehicleDetail;
